<template>
  <div class="block-section-page">
    <div class="banner">
      <p class="title" @click.self="changeHandle">区块信息</p>
      <div class="box-search">
        <el-input v-model="keyword1" placeholder="输入具体高度查询或区块hash查询" clearable>
          <el-button slot="append" @click="searchHandle">查询</el-button>
        </el-input>
        <el-button class="backbtn" type="primary" @click="backIndex">返回</el-button>
      </div>
    </div>
    <block-two ref="blocktwo" :blockobj="blockdetailObj" v-show="currentContent === 'blockDetail'"/>
    <div v-show="currentContent !== 'blockDetail'" class="content-wrapper">
      <div class="block-section-content-one">
      </div>
      <div class="content-three">
        <div class="left">
          <img class="icon" :src="require('../assets/icon/block-1Icon@2x.png')" alt="">
          <div class="number-box">
            <p class="title">目前区块号 latest Blocks</p>
            <p class="number">
              <DigitRoll :rollDigits="topBlockNum" />
            </p>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="right">
          <p class="list-item" v-for="(item, index) in topBlockDetail" :key="index">
            <span class="label">{{item.label}}</span>
            <span class="text">{{item.value}}</span>
          </p>
        </div>
      </div>
      <div class="content-four">
        <div class="number-box">
          <p class="title">最新块号</p>
          <p class="number">{{topBlock.number_1}}</p>
        </div>
        <div class="number-box">
          <p class="title">总块数</p>
          <p class="number">{{topBlock.number_1}}</p>
        </div>
      </div>
      <div class="content-two">
        <el-table
          class="data-table"
          :data="blockList"
          @row-click="animationHandle"
          height="100%" align="left">
          <el-table-column
            prop="number_1"
            label="区块号">
          </el-table-column>
          <el-table-column
            prop="channelName"
            label="区块链名">
          </el-table-column>
          <!-- <el-table-column
            prop="transactions"
            label="交易数">
          </el-table-column> -->
          <el-table-column
            label="块哈希">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.hash }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.hash }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="前块哈希">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.parentHash }}</p>
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.parentHash }}</div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import lottie from 'lottie-web'
import DigitRoll from '@huoyu/vue-digitroll';
import BlockTwo from './blockTwo.vue';
import { blockDetail } from '@/api/chainBrowserApi'
let echarts = require('echarts')
require('moment')
export default {
  props: ['currentIsNew'],
  data() {
    return {
      select: '',
      keyword1: '',
      currentContent: '',
      currentChart: 'lineChart',
      barCharts: '',
      lineCharts: '',
      blockList: [],
      anim: null,
      topBlockNum: 0,
      topBlockDetail: [
      {
          label: '出块节点',
          key: 'stateRoot',
          value: ''
        },{
          label: '交易账户',
          key: 'transactions',
          value: ''
        },{
          label: '块Hash值',
          key: 'hash',
          value: ''
        },
      ],
      blockdetailObj: {}
    }
  },
  components: {
    DigitRoll,
    BlockTwo
  },
  computed: {
    barOption () {
      return this.barOptionInit
    },
    topBlock () {
      let obj = this.blockList[0]
      if (obj) {
        let arry = this.topBlockDetail
        arry.map(item => {
          if (item.key === 'timestamp') {
            let time = parseInt(obj[item.key], 16)
          } else {
            item.value = obj[item.key]
          }
        })
        return obj
      } else {
        return {}
      }
    },
    nowTime () {
      let time = new Date
      let monthAgo = 60*60*12*30
      return time.getTime() - monthAgo
    }
  },
  mounted() {
    // this.initPage()
    this.fetchBlockList()
    this.fetchLineChartData()
    this.subscribeSocket()
    // this.fetchTopBlock()
    // this.reloadAnimation()
  },
  methods: {
    initPage() {
      this.barCharts = echarts.init(document.querySelector('.bar-charts-box'))
      this.lineCharts = echarts.init(document.querySelector('.line-charts-box-inner'))
      this.renderBarChart()
    },
    changeHandle() {
      let pageRoot = document.querySelector('.block-section-page')
      this.$emit('callback', pageRoot)
    },
    animationHandle(data) {
      this.$emit('animationClick', data)
    },
    generateData(count) {
      let baseValue = Math.random() * 1000;
      let time = +new Date(2011, 0, 1);
      let smallBaseValue;

      function next(idx) {
          smallBaseValue = idx % 30 === 0
              ? Math.random() * 700
              : (smallBaseValue + Math.random() * 500 - 250);
          baseValue += Math.random() * 20 - 10;
          return Math.max(
              0,
              Math.round(baseValue + smallBaseValue) + 3000
          );
      }

      let categoryData = [];
      let valueData = [];

      for (let i = 0; i < count; i++) {
          categoryData.push(echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', time));
          valueData.push(next(i).toFixed(2));
          time += 1000;
      }

      return {
          categoryData: categoryData,
          valueData: valueData
      };
    },
    fetchChannel () {
      return this.$http({
        id: 1,
        method: 'net_channelInfo'
      })
    },
    fetchBlockDetail (blockNumber) {
      return this.$http({
        'id': 1,
        params: [blockNumber, true],
        "method":"eth_getBlockByNumber"
      })
    },
    fetchBlockHeight () {
      return this.$http({"id":83, "method":"eth_blockNumber"})
    },
    async fetchLineChartData () {
      let time = new Date()
      time.setDate(time.getDate() - 1)
      let utcTime = (Math.round(time.getTime()/1000)).toString()
      let lineData = await this.$http({
        "method":"eth_getStatistics",
        "params":[utcTime, 'block'],
        "id":1
      })

      let number = (Object.keys(lineData)).length
      this.getAverageTime(number)
    },
    async fetchBlockList () {
      let dataList = await this.$http({
        "method":"eth_getBlocks",
        "params":['0', '10', false],
        "id":1})

      dataList.map(async (item, index) => {
        this.fetchTransNm(item)
        item.number_1 = parseInt(item.number, 16)
        item.channelName = document.title
        item.time = moment(parseInt(item.timestamp, 16)*1000).format('YYYY-MM-DD hh:mm')
        item.anim_key_1 = `Number_${index}`
        item.anim_key_2 = `Text_${index}`
      })
      this.blockList = dataList
      this.topBlockNum = parseInt(this.topBlock.number, 16)
      this.initAnimation()
      if (this.currentIsNew) {
        this.callbackData(dataList[0])
      }
    },
    async fetchTransNm (item) {
      let res = await this.$http({
      "method":"eth_getBlockTransactionCountByNumber",
      "params":[item.number],
      "id":1})
      item.transactions = parseInt(res, 16)
    },
    callbackData(obj) {
      this.$emit('currentNew', obj)
    },
    getAverageTime(number) {
      let averageTime = `${parseInt(60*60*24 / number)} 秒`
      this.$emit('averCallBack', averageTime)
    },
    subscribeSocket() {
      let _self = this
      let data = JSON.stringify({
        "jsonrpc":"2.0",
        "method":"eth_subscribe",
        "params":['newHeads'],
        "id":1
      })
      this.$sockApi(data, async function() {
        await _self.fetchBlockList()
        await _self.fetchLineChartData()
      }, _self)
    },
    initAnimation () {
      let elDom = document.querySelector('.block-section-content-one')
      let aniPath = require('../assets/animation/data5_1.json')
      let arryData = this.blockList.slice(0,5)

      if (this.anim) {
        this.anim.destroy()
      }

      this.anim = lottie.loadAnimation({
        container: elDom,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: aniPath,
      })

      this.anim.addEventListener('DOMLoaded', () => {
        arryData.map(function(item) {
          let data = item

          const element_1 = document.getElementById(data.anim_key_1)
          element_1.innerHTML = `<text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" transform="matrix(1,0,0,1,-48.56500244140625,0)" opacity="1" style="display: inherit;">${data.number_1}</text>`
          const element_2 = document.getElementById(data.anim_key_2)


          let str1 = data.hash.slice(0, 9)
          let str2 = data.hash.slice(9, 16) + '...'
          element_2.innerHTML = `<text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" transform="matrix(1,0,0,1,-55.87799835205078,0)" opacity="1" style="display: inherit;">${str1}</text>\n
          <text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" transform="matrix(1,0,0,1,-52.33599853515625,25)" opacity="1" style="display: inherit;">${str2}</text>`
        })
      })
    },
    searchHandle() {
      if(!this.keyword1) return
      blockDetail({block: this.keyword1}).then(res => {
        this.blockdetailObj = res
        this.$refs['blocktwo'].fetchTrans(res['number'])
      })
      this.currentContent = 'blockDetail'
    },
    backIndex() {
      this.currentContent = ''
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/init-css.scss';

$area-radius: 25px;
$area-padding: .1rem;
$area-margin: .2rem;

.block-section-page {
  .banner {
    // color: #fff;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    .box-search {
      margin-left: 10px;
      display: flex;
      align-items: center;
      width: 500px;
      .backbtn {
        margin-left: 5px;
      }
    }
  }

  .content-wrapper {
    .block-section-content-one {
      display: flex;
      flex-direction: column;
      position: relative;
      flex: 1;
      .button-box-chart {
        display: flex;
        justify-content: center;
        margin: .2rem;
      }

      .line-charts-box {
        flex: 1;
        display: flex;
        align-items: flex-start;
        .button-box {
          display: flex;
          flex-direction: column;
          position: relative;
          right: 4%;
          top: 2%;
          .el-button {
            padding: .05rem;
          }
        }
        .line-charts-box-inner {
          height: 100%;
          flex: 1;
        }
      }

      .bar-charts-box {
        flex: 1;
      }
    }
  }

  .el-button+.el-button {
    margin: 0;
  }

  //--------------------置中样式
  &.section-center {
    display: flex;
    padding-top: 60px;
    .banner {
      font-size: .25rem;
    }
    .content-wrapper {
      width: 100%;
      .block-section-content-one {
        height: 30%;
        margin-bottom: 30px;
      }

      .content-two {
        height: 52%;
        background: #fff;
        border-radius: 10px;
        padding: 4px;
        .el-table {
          height: 100%;
          width: 100%;
          &::before {
            display: none;
          }
          .el-table__body {
            .el-table__row {
              height: 60px;
            }
          }
        }
        .table-button-box {
          text-align: right;
          padding-top: .3rem;
          display: flex;
          justify-content: flex-end;
          .el-button {
            width: 1.5rem;
            color: $font-color;
            border: none;
            background: #14142e;
            &:last-child{
              margin-left: .2rem
            }
          }
        }
      }
    }

    .content-three {
      height: 15%;
      padding: $area-margin 0;
      box-sizing: border-box;
      display: flex;

      .left {
        width: 60%;
        display: flex;
        align-items: center;
        padding-left: 3rem;
        padding-right: 30px;
        .icon {
          height: 95%;
          max-height: 1.6rem;
        }
        .number-box {
          text-align: left;
          margin-left: .5rem;
          flex: 1;
          .title {
            font-size: .15rem;
            position: relative;
            top: .3rem;
          }

          .number {
            font-size: .64rem;
            .d-roll-item {
              flex-grow: unset;
            }
          }
        }
      }
      .vertical-line {
        height: 100%;
        width: 4px;
        border-radius: 1px;
      }
      .right {
        display: flex;
        flex-direction: column;
        font-size: .16rem;
        text-align: left;
        padding-left:.2rem;
        width: 30%;
        justify-content: space-around;
        .list-item {
          display: flex;
          margin: .02rem 0;
          >span {
            display: inline-block;
          }

          .label {
            width: 1rem;
            text-align: right;
          }

          .text {
            margin-left: .2rem;
            width: 50%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .content-four {
      display: none;
    }



  }

  //-------------------------左上样式
  &.section-left {
    display: flex;
    flex-direction: column;
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .banner {
      font-size: .25rem;
      position: absolute;
      top: .2rem;
      left: .4rem;
    }
    .box-search,.content-wrapper .el-input {
      display: none;
    }
    .content-wrapper {
      height: 100%;
      .block-section-content-one {
        height: 30%;
        box-sizing: border-box;
        padding-top: 10%;
      }

      .content-two {
        height: 58%;
        .el-table {
          &::before {
            display: none;
          }
          &.el-table--scrollable-x .el-table__body-wrapper {
            height: 80%;
            overflow: auto;
          }

          td, th {
            padding: 2px 0;
          }
          .el-table__header  th.is-leaf{
            font-size: .12rem;
            height: .2rem;
            // color: #fff;
            padding: .02rem 0;
          }
          .hash-wrapper {
            max-width: .35rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .table-button-box {
          display: flex;
          justify-content: flex-end;
          margin-top: .2rem;
          >.el-button{
            padding: .05rem .1rem;
            border: none;
            background: #58588c;
            &:last-child {
              display: none;
            }
          }
        }
      }
    }

    .content-three {
      display: none;
    }

    .content-four {
      box-sizing: border-box;
      font-size: .16rem;
      text-align: left;
      padding: .2rem 0 .2rem .1rem;

      .number-box {
        display: flex;
        align-items: center;
        .title {
          margin-right: .1rem;
          width: 70px;
          text-align: right;
        }
        .number {
          color: $theme-font-color;
        }
        >p {
          display: inline-block;
        }
      }
    }
  }


  //-------------------左下右下样式
  &.section-bottom-left, &.section-bottom-right {
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .banner {
      font-size: .25rem;
      top: .2rem;
      left: .4rem;
    }

    .box-search,.content-wrapper .el-input {
      display: none;
    }

    .content-wrapper {
      height: 100%;
      .block-section-content-one {
        margin-top: 10%;
        height: 40%;
      }

      .content-two {
        overflow: hidden;
        height: 55%;
        .el-table {
          &::before {
            display: none;
          }
          &.el-table--scrollable-x .el-table__body-wrapper {
            height: 80%;
            overflow: auto;
          }

          td, th {
            padding: 2px 0;
          }
          .el-table__header  th.is-leaf{
            font-size: .12rem;
            height: .2rem;
            padding: .02rem 0;
          }
        }
        .table-button-box {
          display: flex;
          justify-content: flex-end;
          margin-top: .2rem;
          >.el-button{
            padding: .05rem .1rem;
            // color: #fff;
            border: none;
            background: #58588c;
            &:last-child {
              display: none;
            }
          }
        }
      }

    }

    .content-three, .content-four {
      display: none;
    }
  }


}

</style>

<style lang="scss">
@import '@/assets/css/init-css.scss';

.block-section-page {
  .block-section-content-one{
    .button-box-chart {
      .el-button {
        padding: .05rem;
        &:last-child{
          margin-left: .05rem;
        }
      }
    }
  }

  .el-table th, .el-table tr {
    background: none;
    color: #000;
  }
}
</style>
